/**
 * smooth-scroll.js
 * Intercept in-page anchor clicks and smooth-scroll, honoring prefers-reduced-motion.
 */

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;
  const href = link.getAttribute('href');
  if (!href || href === '#') return;
  const target = document.querySelector(href);
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });
  // Update URL hash without jumping (smooth-scroll already handles positioning)
  history.replaceState(null, '', href);
});
